import paymentDetailsToggleTemplate from './paymentDetailsToggle.html';

/*******************************************************************************
 * @ngdoc  component
 * @module makeDeposit
 * @name   csm.books.MakeDeposit.component:paymentDetailsToggle
 * @param  {Boolean} ngModel `true` == Details, `false` == Payments.
 * @description
 * Payment/Details toggle button for `itemList` columns display. Uses `ng-change`
 * to propagate changes to the parent. see: https://stackoverflow.com/a/34001183/2245849.
 *******************************************************************************/
export const paymentDetailsToggleComponent = {
  bindings: { model: '=ngModel' },
  require: { ngModel: '' },
  template: paymentDetailsToggleTemplate
};
